import { LayerRenderStatus, Plugin, PluginOnCanvasLayerRender } from "@react-pdf-viewer/core"

import { drawStampOnCanvas } from "./fileViewerCanvas.utils"

export const customCanvasPlugin = (stamp: string): Plugin => {
    const onCanvasLayerRender = (e: PluginOnCanvasLayerRender) => {
        // Return if the canvas isn't rendered completely
        if (e.status !== LayerRenderStatus.DidRender) {
            return
        }

        // `e.ele` is the canvas element
        const canvas = e.ele
        drawStampOnCanvas({ canvas, stamp, scale: e.scale })
    }
    return {
        onCanvasLayerRender,
    }
}
